import axios from 'axios'
import moment from 'moment-timezone'
import store from '@/store'

export default {
        fetchSchedData(channel, currentDate) {
            store.commit('setReady', false)
            const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
            // make date i.e dec_1
            let d1 = new Date(Date.parse(currentDate))
            let d2 = new Date(Date.parse(d1.toString()) + 86400000)
            let d3 = new Date(Date.parse(d1.toString()) - 86400000)
            let dKey = `${months[d1.getMonth()]}_${d1.getDate()}`

            function genDateA(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${month}/${day}/${date.getFullYear()}`
            }

            function genDateB(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${date.getFullYear()}-${month}-${day}`
            }

            // make today
            let todayDate = genDateB(d1)
            let tomorrowDate = genDateB(d2)
            let yesterdayDate = genDateB(d3)

            // if (channel == 'radio') {
            if (false) {
                axios.get(`https://sched.3abn.org/api/v0.3/?channel=${channel}&date=${todayDate}`)
                .then(res => {

                    res.data.forEach(n => {
                        let d = moment.tz(n.date_str, 'UTC')
                        n.date_str = d.tz(moment.tz.guess()).format()
                        n.date = d.tz(moment.tz.guess()).format('MM/DD/YYYY')
                        n.time = d.tz(moment.tz.guess()).format('h:mma z')

                        let dur = n.duration? n.duration.split(":") : ""
                        let hour = parseInt(dur[0]) ? `${parseInt(dur[0])}h `: ''
                        let min = parseInt(dur[1]) ? `${parseInt(dur[1])}m `: ''
                        // console.log(hour, min)
                        n.duration = `${hour}${min}`
                    })


                    store.commit('addSchedData', {
                        key: dKey,
                        data: res.data.filter(n => {
                            return n.date == genDateA(d1)
                            // return true
                        })
                    })
                    store.commit('setReady', true)
                })
            }
            // decide if next day of previous day should be fetched
            // else if (d1.getTimezoneOffset() >= 0) {
            else {
                axios.get(`https://sched.3abn.org/api/v0.3/?channel=${channel}&start_date=${yesterdayDate}&end_date=${tomorrowDate}`)
                .then(res => {

                    res.data.forEach(n => {
                        let d = moment.tz(n.date_str, 'UTC')
                        n.date_str = d.tz(moment.tz.guess()).format()
                        n.date = d.tz(moment.tz.guess()).format('MM/DD/YYYY')
                        n.time = d.tz(moment.tz.guess()).format('h:mma z')

                        let dur = n.duration? n.duration.split(":") : ""
                        let hour = parseInt(dur[0]) ? `${parseInt(dur[0])}h `: ''
                        let min = parseInt(dur[1]) ? `${parseInt(dur[1])}m `: ''
                        // console.log(hour, min)
                        n.duration = `${hour}${min}`
                    })

                    store.commit('addSchedData', {
                        key: dKey,
                        data: res.data.filter(n => {
                            return n.date == genDateA(d1)
                            // return true
                        })
                    })
                    store.commit('setReady', true)
                })
            // } else if (d1.getTimezoneOffset() < 0) {
            }
        },
        genDayList() {
            const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
            const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']

            function genDateA(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${month}/${day}/${date.getFullYear()}`
            }

            function genDateB(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${date.getFullYear()}-${month}-${day}`
            }

            // make date i.e dec_1
            let d = new Date()
            let x = -(28 + d.getDay())
            let a = []

            for (let i = 0; i < 70; i++) {
                let day = new Date(Date.parse(d.toString()) + (86400000 * x))
                let dateA = genDateA(day)
                let dateB = genDateB(day)
                let dateC = `${months[day.getMonth()]}_${day.getDate()}`
                let dateD = {
                    dayOTW: `${days[day.getDay()]}`,
                    dayN: `${months[day.getMonth()]} ${day.getDate()}`,
                }
                x++
                a.push({dateA, dateB, dateC, dateD})
            }
            store.commit('addGenDays', a)
        },
        fetchRadio(date) {
            store.commit('setReady', false)
            const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
            // make date i.e dec_1
            let d1 = new Date(Date.parse(date))
            let d2 = new Date(Date.parse(d1.toString()) + 86400000)
            let d3 = new Date(Date.parse(d1.toString()) - 86400000)
            let dKey = `${months[d1.getMonth()]}_${d1.getDate()}`

            function genDateA(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${month}/${day}/${date.getFullYear()}`
            }

            function genDateB(date) {
                let month = (`${date.getMonth() + 1}`).length < 2 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
                let day = (`${date.getDate()}`).length < 2 ? `0${date.getDate()}` : `${date.getDate()}`
                return `${date.getFullYear()}-${month}-${day}`
            }


            // make today
            let todayDate = genDateB(d1)
            let tomorrowDate = genDateB(d2)
            let yesterdayDate = genDateB(d3)

            axios.get(`https://3abnapp2.azurewebsites.net/api/scheduledata/?inetworknumber=3&dDate=${date}&TimeZoneName=0`)
                .then(res => {
                    res.data.forEach(n => {
                        let d = moment.tz(n.UTCDateTime, 'UTC')
                        n.date_str = d.tz(moment.tz.guess()).format()
                        n.date = d.tz(moment.tz.guess()).format('MM/DD/YYYY')
                        n.time = d.tz(moment.tz.guess()).format('h:mma z')

                        let dur = n.Duration.split(":")
                        let hour = parseInt(dur[0]) ? `${parseInt(dur[0])}h `: ''
                        let min = parseInt(dur[1]) ? `${parseInt(dur[1])}m `: ''
                        // console.log(hour, min)
                        n.duration = `${hour}${min}`

                        n.ProgramCode = n.program_code
                        n.Series = n.series_title
                        n.Content = n.description
                        n.Guests = n.guest
                    })


                    store.commit('addSchedData', {
                        key: dKey,
                        data: res.data.filter(n => {
                            return n.date == genDateA(d1)
                            // return true
                        })
                    })
                    store.commit('setReady', true)
                })

        }
    }



// WEBPACK FOOTER //
// ./src/lib/index.js